import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

export class RomReview extends Component {
    render() {
        const {
            onChange,
            onChangeDate,
            reasonfortheRomReview,
            //romExpertName,
            //coMonitor,
            fieldPhaseStartDate,
            fieldPhaseEndDate,
            userType,
        } = this.props;
        return (
            <Card>
                <CardHeader
                    title="Rom Review - Key Information"
                    className="romis-card-header"
                />
                <CardContent>
                    <TextField
                        label="Reason for the ROM Review:"
                        placeholder="Reason"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true
                        }}
                        onChange={onChange}
                        value={reasonfortheRomReview}
                        name="reasonfortheRomReview"
                        disabled={userType !== 2 ? true : false}
                    />

                    {
                        //<TextField
                        //    label="ROM Monitor :"
                        //    placeholder="ROM Monitor"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true
                        //    }}
                        //    onChange={onChange}
                        //    value={romExpertName}
                        //    name="romExpertName"
                        ///>
                        //<TextField
                        //    label="CO Monitor :"
                        //    placeholder="CO Monitor"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true
                        //    }}
                        //    onChange={onChange}
                        //    value={coMonitor}
                        //    name="coMonitor"
                        ///>
                    }

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            margin="normal"
                            variant="inline"
                            label="Field Phase Start Date:"
                            format="dd/MM/yyyy"
                            fullWidth
                            onChange={value => {
                                onChangeDate("fieldPhaseStartDate", value);
                            }}
                            //value={
                            //    fieldPhaseStartDate === "" ? new Date() : fieldPhaseStartDate
                            //}
                            value={fieldPhaseStartDate}
                            name="fieldPhaseStartDate"
                            InputLabelProps={{
                                shrink: true
                            }}
                            autoOk
                            disabled={userType !== 2 ? true : false}
                        />
                    </MuiPickersUtilsProvider>

                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            margin="normal"
                            variant="inline"
                            label="Field Phase End Date:"
                            format="dd/MM/yyyy"
                            fullWidth
                            onChange={value => {
                                onChangeDate("fieldPhaseEndDate", value);
                            }}
                            //value={
                            //    fieldPhaseStartDate === "" ? new Date() : fieldPhaseStartDate
                            //}
                            value={fieldPhaseEndDate}
                            name="fieldPhaseEndDate"
                            InputLabelProps={{
                                shrink: true
                            }}
                            autoOk
                            disabled={userType !== 2 ? true : false}
                        />
                    </MuiPickersUtilsProvider>
                </CardContent>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/RomReview.js